import {
  SET_PROPOSAL_PILOT,
} from './types';

const proposalReducer = (state, action) => {
  switch (action.type) {
    case SET_PROPOSAL_PILOT:
      return {
        ...state,
        pilot: action.payload,
      };
    default:
      return state;
  }
};

export default proposalReducer;
